import React, { useState } from 'react';

const AutoTrain = () => {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-gray-700 font-medium">Auto train</span>
      <label className="switch switch-sm">
        <input
          type="checkbox"
          checked={enabled}
          onChange={() => setEnabled(v => !v)}
          className='px-5'
        />
      </label>
    </div>
  );
};

export { AutoTrain }; 